<template>
    <Main>
        <template v-slot:toolbar>
        <div class="white">
            <ToolbarQuotationStep
              class="max-content-width"
              v-if="currentStep != steps.edit"
              :steps-quotation="stepsQuotation"
            />
        </div>
        </template>
        <template v-slot:breadcrumb>
        <BaseBreadcrumb
            :items="breadcrumb"
            v-if="currentStep == steps.edit"
            visible-button
            class="d-none d-sm-flex"
        />
        </template>
        <template v-slot:breadcrumb-mobile>
        <BaseBreadcrumb
            :items="breadcrumb"
            v-if="currentStep == steps.edit"
            visible-button
        />
        </template>
        <QuotationEditForm
            :form="currentQuotationToEdit"
            @submit="submit"
            v-if="currentStep == steps.edit"
            @return="changeToCostStep"
        />
        <QuotationStepModality
            v-if="currentStep == steps.modality"
            @updateStep="changeStep"
            :form="formAccordingStep"
            :options-quotation="optionsQuotation"
            @updateOptions="updateOptions"
        />
        <QuotationStepCompany
            v-if="currentStep == steps.company"
            @updateStep="changeStep"
            :form="formAccordingStep"
            :readonly-form="getForm('quotation step modality')"
        />
        <QuotationStepInsured
            v-if="currentStep == steps.insured"
            @updateStep="changeStep"
            :form="formAccordingStep"
            :readonly-form="getForm('quotation step company')"
            :options-quotation="optionsQuotation"
        />
        <QuotationFirstStepResource
            v-if="currentStep == steps.firstResource"
            @updateStep="changeStep"
            :form="formAccordingStep"
            :readonly-form="getForm('quotation step modality')"
        />
        <QuotationSecondStepResource
        v-if="currentStep == steps.secondResource"
            :previous="previousStep"
            @updateStep="changeStep"
            :form="formAccordingStep"
            :readonly-form="getForm('quotation step select resource')"
            :first-form="getForm('quotation step modality')"
        />
        <QuotationStepResourceWithoutModalityRecursal
            v-if="currentStep == steps.resourceWithoutRecursal"
            :previous="previousStep"
            @updateStep="changeStep"
            :form="formAccordingStep"
            :first-form="getForm('quotation step modality')"
        />
        <QuotationStepDeadline
            v-if="currentStep == steps.deadline"
            @newQuotation="uploadNewQuotation"
            @updateStep="changeStep"
            :form="formAccordingStep"
            :readonly-form="getForm('quotation step modality')"
            :options-quotation="optionsQuotation"
        />
        <QuotationStepCost
            v-if="currentStep == steps.cost"
            :form="formAccordingStep"
            @new="getNewQuotation"
            @edit="changeViewToEdit"
            @cancel="cancelProcess"
        />
        <ModalCancelQuotation @close="closeModal" v-model="modalCancel" />
    </Main>
</template>
<script>
import QuotationStepModality from "../new_quotation_steps/QuotationStepModality";
import QuotationStepCompany from "../new_quotation_steps/QuotationStepCompany";
import QuotationStepInsured from "../new_quotation_steps/QuotationStepInsured";
import QuotationFirstStepResource from "../new_quotation_steps/QuotationFirstStepResource";
import QuotationSecondStepResource from "../new_quotation_steps/QuotationSecondStepResource";
import QuotationStepResourceWithoutModalityRecursal from "../new_quotation_steps/QuotationStepResourceWithoutModalityRecursal";
import QuotationStepDeadline from "../new_quotation_steps/QuotationStepDeadline";
import QuotationStepCost from "../new_quotation_steps/QuotationStepCost";
import ModalCancelQuotation from "../components/ModalCancelQuotation";
import QuotationEditForm from "../components/QuotationEditForm";
import { mapState, mapActions } from "vuex";
import { QuotationMixin } from "@/mixins/NewQuotationMixin";
import { LoadingRequest } from "@/mixins/LoadingMixin";
import _ from "lodash";
const tabSteps = {
  modality: "quotation step modality",
  company: "quotation step company",
  insured: "quotation step insured",
  resourceWithoutRecursal: "quotation step resource without recursal",
  firstResource: "quotation step select resource",
  secondResource: "quotation step form resource",
  deadline: "quotation step deadline",
  cost: "quotation step cost",
  edit: "quotation edit"
};
const itemSteps = [
  {
    form: {
      modality: null,
      subModality: null,
      emissionType: null
    },
    step: tabSteps.modality
  },
  {
    form: {
      economicGroup: null,
      taker: null
    },
    step: tabSteps.company
  },
  {
    form: {
      tipo_pessoa: {
        id: null,
        nome: null
      },
      numero_documento: null,
      nome: null,
      endereco: {
        cep: null,
        logradouro: null,
        numero: null,
        complemento: null,
        bairro: null,
        cidade: null,
        uf: null
      }
    },
    step: tabSteps.insured
  },
  {
    form: {
      resource: null
    },
    step: tabSteps.firstResource
  },
  {
    form: {
      value: null,
      insuredAmount: null,
      percent: "30%"
    },
    step: tabSteps.secondResource
  },
  {
    form: {
      valor_importancia_segurada: 0,
      composicao_importancia_segurada: null
    },
    step: tabSteps.resourceWithoutRecursal
  },
  {
    form: {
      date: null,
      prazo: null,
      date_end: null,
      tipo_processo: {
        id: null,
        title: null
      },
      numero_processo: null,
      tribunal: null,
      unidade: null,
      numberProposal: null,
      segmento: {
        id: "justica_trabalho"
      },
      escritorio: {
        id: "00000000-0000-0000-0000-000000000000",
        nome_fantasia: "NENHUM"
      },
      nome_tribunal: null,
      nome_unidade: null,
      anexos: []
    },
    step: tabSteps.deadline
  },
  {
    form: {},
    step: tabSteps.cost
  }
];
const firstStep = {
  name: "quotation step modality",
  step: 1
};
const STEP_ONE_QUOTATION = {
  name: "1. Modalidades",
  router: "quotation step modality",
  step: 1
};
const STEP_TWO_QUOTATION = {
  name: "2. Partes",
  router: "quotation step company",
  step: 2
};
const STEP_THREE_QUOTATION = {
  name: "3. Recursos",
  router: "quotation step resource",
  step: 3
};
const STEP_FOUR_QUOTATION = {
  name: "4. Prazos",
  router: "quotation step deadline",
  step: 4
};
const STEP_FIVE_QUOTATION = {
  name: "5. Custos",
  router: "quotation step cost",
  step: 5
};
const STEP_THREE_OTHER_QUOTATION = {
  name: "3. Importância Segurada",
  router: "quotation step resource",
  step: 3
};
export default {
  name: "NewQuotationGarantia",
  beforeRouteLeave(to, from, next) {
    if (
      (this.currentStep == "quotation step cost" && !this.quotationId) ||
      this.itemSteps[0].form.modality == null ||
      this.currentStep == "quotation edit"
    )
      next();
    this.modalCancel = true;
    this.nextRoute = to;
    if (this.cancel) next();
  },
  data: () => ({
    currentStep: "quotation step modality",
    steps: tabSteps,
    itemSteps: {},
    cancel: false,
    modalCancel: false,
    previousStep: "quotation step modality",
    breadcrumb: [
      {
        text: "Editar dados",
        to: "quotation element"
      }
    ],
    quotationId: null,
    optionsQuotation: {
      tipos_emissao: [],
      recursos: {
        obrigatorio: true
      }
    }
  }),
  components: {
    QuotationStepModality,
    QuotationStepCompany,
    QuotationStepInsured,
    QuotationFirstStepResource,
    QuotationSecondStepResource,
    QuotationStepResourceWithoutModalityRecursal,
    QuotationStepDeadline,
    QuotationStepCost,
    ModalCancelQuotation,
    QuotationEditForm
  },
  mixins: [QuotationMixin, LoadingRequest],
  computed: {
    ...mapState("quotation", ["infoCostQuotation", "currentQuotationToEdit"]),
    formAccordingStep() {
      return this.itemSteps.find(x => x.step == this.currentStep).form;
    },
    stepsQuotation() {
      return [
        STEP_ONE_QUOTATION,
        STEP_TWO_QUOTATION,
        this.optionsQuotation.recursos.obrigatorio
          ? STEP_THREE_QUOTATION
          : STEP_THREE_OTHER_QUOTATION,
        STEP_FOUR_QUOTATION,
        STEP_FIVE_QUOTATION
      ];
    }
  },
  created() {
    // pegar uma cópia em vez de uma referência, para
    // quando for cancelada e depois ela iniciar uma nova,
    // ela esteja resetada
    this.itemSteps = _.cloneDeep(itemSteps);
    this.updateCurrentQuotationStep(firstStep);
  },
  methods: {
    ...mapActions("quotation", [
      "updateCurrentQuotationStep",
      "makeNewQuotation",
      "requestEditQuotation",
      "requestCurrentQuotationToEdit",
      "requestCancelQuotation"
    ]),
    ...mapActions(["showAlertNotification"]),
    updateOptions(item) {
      this.optionsQuotation = item;
    },
    changeStep(payload) {
      this.itemSteps.find(x => x.step == this.currentStep).form = payload.form;
      this.updateCurrentQuotationStep(payload.step);
      this.previousStep = _.cloneDeep(this.currentStep);
      this.currentStep = payload.step.name;
    },
    closeModal(value) {
      if (this.quotationId && value) {
        this.cancel = false;
        this.withLoading(
          this.requestCancelQuotation(this.quotationId).then(() => {
            this.cancel = true;
          })
        );
      } else {
        this.cancel = value;
      }
      this.modalCancel = false;
      this.quotationId = null;
      if (value) {
        this.updateCurrentQuotationStep(firstStep);
        this.$router.push({ name: this.nextRoute.name });
      }
    },
    getForm(item) {
      return this.itemSteps.find(x => x.step == item).form;
    },
    getNewQuotation(value, id) {
      this.updateCurrentQuotationStep(firstStep);
      if (value) {
        // voltar para primeira etapa caso o usuário
        // queria fazer uma nova cotação e resetar
        // valores da antiga cotação.
        // TODO: fazer integração para guardar
        // última cotação.
        this.currentStep = firstStep.name;
        this.itemSteps = _.cloneDeep(itemSteps);
      } else {
        // ir para tela de lista de cotações caso ele
        // não queria fazer uma nova cotação.
        this.cancel = true;
        this.$router.push({ name: "quotation element", params: { id: id } });
      }
    },
    async uploadNewQuotation(value) {
      this.withLoading(
        this.makeNewQuotation(
          await this.getPayloadNewQuotation(this.itemSteps, value.form)
        ).then(() => this.changeStep(value))
      );
    },
    changeViewToEdit() {
      this.withLoading(
        this.requestCurrentQuotationToEdit(this.infoCostQuotation.id)
      );
    },
    changeToCostStep() {
      this.currentStep = "quotation step cost";
    },
    async submit(form) {
      this.withLoading(
        this.requestEditQuotation(
          await this.getEditPayload(form, this.infoCostQuotation.id)
        ).then(() => {
          this.showAlertNotification({
            message: "Cotação editada com sucesso",
            type: "success"
          });
          this.$router.push({
            name: "quotation element",
            params: { id: this.infoCostQuotation.id }
          });
        })
      );
    },
    cancelProcess(id) {
      this.quotationId = id;
      this.$router.push({ name: "quotation" });
    }
  },
  watch: {
    currentQuotationToEdit() {
      this.currentStep = "quotation edit";
    }
  }
};
</script>
